export const MulFiles = {
  "Modal": {
    "Title": "Convert Multiple Files",
    "Total": "Total {count} files"
  },
  "Button": {
    "AddFiles": "Add Files",
    "AddCurrentDocument": "Add Open File",
    "Delete": "Delete",
    "Cancel": "Cancel",
    "Convert": "Convert",
    "MoveUp": "Move up",
    "MoveDown": "Move down",
    "Remove": "Remove",
    "Options": "Options",
    "OK": "OK",
    "Yes": "Yes",
    "No": "No"
  },
  "Table": {
    "All": "All",
    "Name": "Name",
    "Date": "Modified",
    "Size": "Size",
    "Range": "Range",
    "Status": "Conversion Status",
    "Password": "You do not have access rights to this encrypted document.",
    "Successful": "Successful"
  },
  "ErrorCode": {
    "900003": "Failed to parse",
    "81000017": "You do not have access rights to this encrypted document.",
    "81000034": "XML format cannot be merged."
  },
  "Msg": {
    "AddCurrentFileFailed": "Failed to add the current document",
    "AddFilesSuccess": "Files added",
    "TotalSizeLarge": "The files you added are more than 200 MB, it may take longer than usual to combine them. Do you want to continue?",
    "TotalSizeLargeTitle": "Add file",
    "TotalSizeOver": "The total file size cannot be greater than 1GB.",
    "SingleFileSizeOver": "The size of each file cannot be greater than 1GB.",
    "FilesAllBroken": "All files are corrupted, so they could not be combined.",
    "FileUploadFailed": "File upload failed",
    "UnsupportedFile": "Unsupported file",
    "UploadFailed": "Upload failed",
    "PreviewInfo": "Preview the non-PDF files? (Needs to be converted)",
    "Coverting": "Coverting",
    "ConverteSuccessful": "Successful",
    "ConverteFail": "Conversion Failed"
  },
  "Confirm": {
    "DeleteConfirm": "Do you want to delete the selected file?"
  },
  "Alert": {
    "PasswordTitle": "Password",
    "Password": "The file '%filename%' is protected. Please enter a Permission Password.",
    "Enter": "Enter Password:",
    "WrongPassword": "Invalid password, please input again."
  }
}